import {Component, Input, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';

/**
 *  Show form errors that do not belong to a field (field value is blank in the case)
 *
 */
@Component({
    selector: 'formMsg',
    moduleId: module.id,
    templateUrl: './formMsg.component.html'
})
export class FormMsgComponent implements OnInit {

    @Input() form: FormGroup;   // form control

    private field = '';

    ngOnInit() {
    }

    get errorsExt() {
        return this.form['errorsExt'] && this.form['errorsExt'][this.field] ? this.form['errorsExt'][this.field] : [];
    }

}
